import {useTranslation} from "../../../../__snowpack__/link/packages/old-i18n/dist/i18n.esm.js";
import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import Button from "../../atoms/button/button.component.js";
import Modal from "../../atoms/modal/modal.component.js";
function MainDeleteDialog({
  children,
  header,
  show,
  width = "30rem",
  height = "20rem",
  onCancel,
  onDelete
}, ref) {
  const modalRef = useRef(null);
  const [isOpen, setIsOpen] = useState(show);
  useEffect(() => {
    setIsOpen(show);
  }, [show]);
  const {
    t
  } = useTranslation();
  useImperativeHandle(ref, () => modalRef.current, []);
  const actions = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Button, {
    onClick: onCancel,
    role: "cancel-button"
  }, t("actions.cancel")), /* @__PURE__ */ React.createElement(Button, {
    onClick: onDelete,
    role: "delete-button",
    color: "var(--errorColor)",
    textColor: "white"
  }, t("actions.deleteConfirm")));
  return /* @__PURE__ */ React.createElement(Modal, {
    ref: modalRef,
    show: isOpen,
    persistent: true,
    dismiss: false,
    header,
    actions,
    width,
    height
  }, children);
}
const DeleteDialog = /* @__PURE__ */ forwardRef(MainDeleteDialog);
DeleteDialog.displayName = "DeleteDialog";
export default DeleteDialog;
